import { render, staticRenderFns } from "./bulk-delete-checkbox.vue?vue&type=template&id=0c36b930&scoped=true"
import script from "./bulk-delete-checkbox.vue?vue&type=script&lang=js"
export * from "./bulk-delete-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36b930",
  null
  
)

export default component.exports